<template >
    <div class="custimize-iframe">
        <div class="iframe-cont">
            <iframe src="https://ai.tcmcds.com/zhGraph/res/content_bzy.html?keywords=%E4%BA%BA%E5%8F%82" frameborder="0"></iframe>
        </div>
    </div>
</template>
<script>
export default {
    
}
</script>
<style lang="less" scoped>
.custimize-iframe{
    width: 100%;
    min-width: 1200px;
    background: #f5f5f5;
    .iframe-cont{
        width: 1200px;
        height: 836px;
        margin: 0 auto; 
        ::v-deep iframe{
            width: 100%;
            height: 100%;
        }
    }
}
</style>